import { useLayoutEffect } from 'react';

/**
 * This hook is used as workaround to avoid google translation causing rendering issues
 * when moving between pages.
 */
const COUNTRIES = ['hk'];

export const useGoogleTranslateDOMFix = (country: string) => {
  useLayoutEffect(() => {
    if (COUNTRIES.includes(country)) {
      if (typeof Node === 'function' && Node.prototype) {
        const originalRemoveChild = Node.prototype.removeChild;
        Node.prototype.removeChild = function <T extends Node>(child: T): T {
          if (child.parentNode !== this) {
            if (console) {
              // eslint-disable-next-line no-console
              console.error(
                'Cannot remove a child from a different parent',
                child,
                this,
              );
            }
            return child;
          }
          return originalRemoveChild.call(this, child) as T;
        };

        const originalInsertBefore = Node.prototype.insertBefore;
        Node.prototype.insertBefore = function <T extends Node>(
          newNode: T,
          referenceNode: Node | null,
        ): T {
          if (referenceNode && referenceNode.parentNode !== this) {
            if (console) {
              // eslint-disable-next-line no-console
              console.error(
                'Cannot insert before a reference node from a different parent',
                referenceNode,
                this,
              );
            }
            return newNode;
          }
          return originalInsertBefore.call(this, newNode, referenceNode) as T;
        };
      }
    }
  }, [country]);
};
